import ServiceCard from "./ServiceCard";

const SelectedServicesBody = ({ data }) => {
    const { selectedServices } = data;

    return (
        <div className="">
            {selectedServices.length === 0 ? (
                <div className="flex min-h-[120px] items-center justify-center px-4 text-center text-gray-500">
                    Chưa chọn dịch vụ nào
                </div>
            ) : (
                <div className="p-4">
                    {selectedServices.map((service, index) => (
                        <ServiceCard
                            key={service.id}
                            service={service}
                            index={index}
                            data={data}
                        />
                    ))}
                </div>
            )}
        </div>
    );
};

export default SelectedServicesBody;
